module.exports = __webpack_public_path__ + "img/menu_center_bg.b3705956.png";